import { useEffect } from "react";
import isAncestor from "../../components/drops/mixins/isAncestor";
export default (function (dropRef, onClickOutside, target) {
    useEffect(function () {
        if (!onClickOutside)
            return;
        var onMousedown = function (event) {
            if (event.target !== dropRef.current &&
                // dont fire when clicking in drop
                !isAncestor(dropRef.current, event.target) &&
                // dont fire when clicking dropdown-button
                !isAncestor(target, event.target)) {
                onClickOutside(event);
            }
        };
        document.addEventListener("mousedown", onMousedown);
        return function () { return document.removeEventListener("mousedown", onMousedown); };
    }, [onClickOutside]);
});
